import * as React from 'react';
const Check = (props) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} fill='none' {...props}>
		<path stroke='#1f1f43b3' strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='m9 11 3 3 8-8' />
		<path stroke='#1f1f43b3' strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9' />
	</svg>
);
export default Check;
